import React from 'react';
import { HStack } from '@chakra-ui/react';
import PhotoGridItem from '../../FindingPanel/PhotoGridItem';
import MediaViewer from '../../MediaViewer/MediaViewer';
const MAX_PHOTOS = 1;
const RemoteSubmissionPhotoPanel = ({ remoteSubmission, loadedPhotos, isShare = false, }) => {
    const { photos } = remoteSubmission;
    const displayedPhotos = photos.slice(0, MAX_PHOTOS);
    return (React.createElement(MediaViewer, { isShare: isShare, allMedia: photos, loadedPhotos: loadedPhotos }, ({ onMediaClick, onMediaKeyDown, onOpenAtStart }) => (React.createElement(HStack, { "data-testid": "remote_submission_photo_panel" }, displayedPhotos.map((photo, index) => {
        const loadedPhoto = loadedPhotos?.find((p) => p.id === photo.id);
        return (React.createElement(PhotoGridItem, { cursor: "pointer", key: photo.id, photo: photo, canShowBadge: index === MAX_PHOTOS - 1, shouldLoad: !loadedPhoto, maxToShow: MAX_PHOTOS, photoCount: photos.length, shouldIncreaseSize: false, loadedPhoto: loadedPhoto, clickHandler: () => onMediaClick(photo), keyDownHandler: (e) => onMediaKeyDown(e, photo), onOpenAtStart: onOpenAtStart, isShare: isShare }));
    })))));
};
export default React.memo(RemoteSubmissionPhotoPanel);
